import { render, staticRenderFns } from "./detailAbnormal.vue?vue&type=template&id=4bd8ad33&scoped=true"
import script from "./detailAbnormal.vue?vue&type=script&lang=js"
export * from "./detailAbnormal.vue?vue&type=script&lang=js"
import style0 from "./detailAbnormal.vue?vue&type=style&index=0&id=4bd8ad33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8ad33",
  null
  
)

export default component.exports